import Modal from '@/components/Modal';

type ConfirmationModalProps = {
  id: string;
  title: string;
  description: string | React.ReactNode;
  size?: 'small' | 'medium' | 'large';
  onCancelLabel?: string;
  onConfirmLabel?: string;
  onClose?: () => void;
  onCancel?: () => void;
  onConfirm: () => void;
};

const ConfirmationModal = ({
  id,
  title,
  description,
  size = 'small',
  onConfirmLabel = 'Valider',
  onClose,
  onCancel,
  onConfirm,
}: ConfirmationModalProps) => {
  return (
    <Modal
      id={id}
      title={title}
      centerY
      size={size}
      onClose={onClose}
      onClickCancelBtn={onCancel}
      onClickSecondBtn={onConfirm}
      showSecondBtn
      secondBtnLabel={onConfirmLabel}
    >
      <p>{description}</p>
    </Modal>
  );
};

export default ConfirmationModal;
